var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/outline/check-rectangle",
    clipPath: "url(#clip0_0_141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 1.33333H12C13.4728 1.33333 14.6667 2.52724 14.6667 4V12C14.6667 13.4728 13.4728 14.6667 12 14.6667H4C2.52724 14.6667 1.33333 13.4728 1.33333 12V4C1.33333 2.52724 2.52724 1.33333 4 1.33333Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRect);
export default __webpack_public_path__ + "static/media/check-rect.94913a35f0d208865d923783cff1f3ec.svg";
export { ForwardRef as ReactComponent };